// extracted by mini-css-extract-plugin
export default {"closeModal":"ProductModal_closeModal__0R4ct","title":"ProductModal_title__wJg7S","textWrapper":"ProductModal_textWrapper__ZCE+Y","description":"ProductModal_description__pc3k0"};